/* eslint-disable react/no-array-index-key */
/* eslint-disable react/jsx-props-no-spreading */
import React, { FC, HTMLProps } from 'react';
import classNames from 'classnames';
import useBreadcrumbs from 'hooks/use-breadcrumbs';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ReactComponent as ArrowRight } from 'assets/icons_3/arrows/chevron-right.svg';
import styles from './Breadcrumbs.module.scss';

interface IBreadcrumbsProps extends HTMLProps<HTMLDivElement> {

}

const Breadcrumbs: FC<IBreadcrumbsProps> = ({ className, ...props }) => {
  const breadcrumbs = useBreadcrumbs();
  const [t] = useTranslation();

  return (
    <nav className={classNames(styles.breadcrumbs, className)} {...props} qa-element="breadcrumbs">
      {breadcrumbs.map((c, i, arr) => {
        if (arr.length === 1) {
          return (
            <h1 key={c.to + i} className={styles.singleHeader} {...(c.qaElement ? { 'qa-element': c.qaElement } : {})}>
              {c.isFromApi ? c.label
                : t(c.label)}
            </h1>
          );
        }

        if (i === arr.length - 1) {
          return (
            <h1 key={c.to + i} className={styles.lastRoute} {...(c.qaElement ? { 'qa-element': c.qaElement } : {})}>
              {c.isFromApi ? c.label
                : t(c.label)}
            </h1>
          );
        }

        return (
          <React.Fragment key={c.to}>
            <Link
              className={styles.middleRoute}
              to={c.to}
              state={c.state}
              {...(c.qaElement ? { 'qa-element': c.qaElement } : {})}
            >
              {c.isFromApi ? c.label
                : t(c.label)}
            </Link>
            <ArrowRight className={styles.arrow} />
          </React.Fragment>
        );
      })}
    </nav>
  );
};

export default Breadcrumbs;
